import { render } from "./ItemView.vue?vue&type=template&id=660f7dd6&scoped=true&ts=true"
import script from "./ItemView.vue?vue&type=script&lang=ts"
export * from "./ItemView.vue?vue&type=script&lang=ts"

import "./ItemView.vue?vue&type=style&index=0&id=660f7dd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660f7dd6"]])

export default __exports__